// import { Close, VolumeUp } from '@mui/icons-material';
// import { Box, Button, CircularProgress, Divider, IconButton, MenuItem, Modal, TextField, Typography } from '@mui/material';
// import React, { useEffect, useState } from 'react'
// import { Stack } from '@mui/material';
// import { LoadingButton } from '@mui/lab';
// import ReactAudioPlayer from 'react-audio-player';
// import Axios from '../../../../../../axios/Axios';
// import dayjs from 'dayjs';
// import { showSnackbar } from '../../../../../redux/features/appSlice';
// import { useDispatch } from 'react-redux';
// import axios from 'axios';

// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: 1000,
//     bgcolor: 'background.paper',
//     boxShadow: 24,
//     p: 2,
// };

// const styleBox = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: 500,
//     bgcolor: 'background.paper',
//     boxShadow: 24,
//     p: 2,
//     borderRadius: "8px"
// }

// function AudioDetails({ openAudioModal, setOpenAudioModal, requestData, pageReload }) {
//     // console.log(openAudioModal );
//     // console.log(setOpenAudioModal);
//     // console.log(requestData);
//     const dispatch = useDispatch();
//     const [studentAudioData, setStudentAudioData] = useState({
//         isLoading: false,
//         isError: false,
//         isSuccess: false,
//         data: [],
//         error: null,
//         // level_name,
//     });

//     const [updateAudioStatusAndReason, setUpdateAudioStatusAndReason] = useState({
//         isLoading: false,
//         status: false,
//         data: [],
//     });
//     const updatedData = { ...studentAudioData.data[0] }
//     delete updatedData.audio_details;
//     //    console.log(updatedData);
//     const { student_id, level_id, session_id } = updatedData;

//     const value = {
//         studentDetails: {
//             student_id,
//             level_id,
//             session_id,
//             teacher_id: requestData.teacherId,

//         },
//         audio: updateAudioStatusAndReason.data
//     }
//     const [disableButton, setDisableButton] = useState(false)

//     //    console.log(value,"value");
//     //        console.log(studentAudioData.data[0], "audio");
//     // console.log(updateAudioStatusAndReason.data, "new data");

//     /* Get Audio details from API */
//     useEffect(() => {
//         const controller = axios.CancelToken.source();

//         if (requestData.studentId && requestData.levelId && requestData.levelName) {

//             (async () => {
//                 try {
//                     setStudentAudioData(prev => ({ ...prev, isLoading: true, isSuccess: false, isError: false, data: [], error: null }))
//                     let options = requestData.levelName === "level0" ? {
//                         method: "GET",
//                         url: `audio/student/level0/audio/for/spoc/${requestData.studentId}`,
//                         auth: true,
//                         data: null,
//                         token: { cancelToken: controller.token }
//                     } : {
//                         method: "POST",
//                         url: "audio/student/level/status/for/spoc",
//                         auth: true,
//                         data: {
//                             student_id: requestData.studentId,
//                             level_id: requestData.levelId
//                         },
//                         token: { cancelToken: controller.token }
//                     };

//                     const response = await Axios(
//                         options.method,
//                         options.url,
//                         options.auth,
//                         options.data,
//                         options.token,
//                     );

//                     // console.log(response);
//                     if (response.status === 200) {
//                         setStudentAudioData(prev => ({ ...prev, isSuccess: true, data: response.data }));
//                         // setUpdateAudioStatusAndReason(prev =>({...prev, ...response.data[0]}))
//                     }
//                 } catch (error) {
//                     if (!axios.isCancel(error)) {
//                         setStudentAudioData(prev => ({ ...prev, isError: true, error: error.data }))
//                         console.log(error);
//                     }
//                 }
//             })()
//         }

//         return () => {
//             controller.cancel();
//         }
//     }, [requestData]);

//     /* Update audio status and reason for student */
//     async function updateAudioStatusOfStudent() {
//         try {
//             setUpdateAudioStatusAndReason(prev => ({ ...prev, isLoading: true }))
//             let options = {
//                 method: "PUT",
//                 url: "audio/student/approval/by/user",
//                 auth: true,
//                 data: value,
//             }

//             const response = await Axios(
//                 options.method,
//                 options.url,
//                 options.auth,
//                 options.data
//             );

//             // console.log(response);
//             if (response.status === 200 || response.status === 201) {
//                 await fetchAudioDetails();
//                 setUpdateAudioStatusAndReason(prev => ({ ...prev, isLoading: false }));
//                 dispatch(
//                     showSnackbar({
//                         message: "Audio status updated successfully",
//                         severity: "success",
//                     })
//                 );
//             }
//         } catch (error) {
//             setUpdateAudioStatusAndReason(prev => ({ ...prev, isLoading: false }));
//             dispatch(
//                 showSnackbar({
//                     message: "Failed updating audio status, Try again",
//                     severity: "error",
//                 })
//             );

//             console.log(error);
//         }
//     }

//     async function fetchAudioDetails() {
//         try {
//             setStudentAudioData(prev => ({ ...prev, isLoading: true, isSuccess: false, isError: false, data: [], error: null }))
//             let options = requestData.levelName === "level0" ? {
//                 method: "GET",
//                 url: `audio/student/level0/audio/for/spoc/${requestData.studentId}`,
//                 auth: true,
//                 data: null,
//             } : {
//                 method: "POST",
//                 url: "audio/student/level/status/for/spoc",
//                 auth: true,
//                 data: {
//                     student_id: requestData.studentId,
//                     level_id: requestData.levelId
//                 },
//             };

//             const response = await Axios(
//                 options.method,
//                 options.url,
//                 options.auth,
//                 options.data
//             );

//             // console.log(response);
//             if (response.status === 200) {
//                 setStudentAudioData(prev => ({ ...prev, isSuccess: true, data: response.data }));
//                 // setUpdateAudioStatusAndReason(prev =>({...prev, ...response.data[0]}))
//             }
//         } catch (error) {
//             setStudentAudioData(prev => ({ ...prev, isError: true, error: error.data }))
//             console.log(error);
//         }
//     }

//     const closeFunction = () => {
//         pageReload()
//         setOpenAudioModal(false)
//     }

//     /* Render audio details */
//     let content;

//     if (studentAudioData.isLoading) {
//         content = (<Box sx={{ p: 5, margin: "0 auto" }}>
//             <CircularProgress />
//         </Box>)
//     }

//     if (studentAudioData.isError) {
//         content = (<Box sx={{ p: 5, margin: "0 auto" }}>
//             <p>{studentAudioData.error}</p>
//         </Box>)
//     }

//     if (studentAudioData.isSuccess) {

//         if (studentAudioData.data.length === 0 || studentAudioData.data[0] === null) {
//             content = (<Box sx={{ p: 5, margin: "0 auto" }}>
//                 <p>Data not available</p>
//             </Box>)
//         } else if (studentAudioData.data[0]?.audio_details[0] === null) {
//             content = (<Box sx={{ p: 5, margin: "0 auto" }}>
//                 <p>Audio file not available</p>
//             </Box>)
//         } else {
//             content = studentAudioData.data.map((audiodata, i) => {
//                 return (
//                     <Stack key={i} pt={1}>
//                         <Typography fontWeight="bold" variant='subtitle1' color="#1d3faa">
//                             {audiodata.level_name} - {audiodata.session_name}
//                         </Typography>
//                         {audiodata.audio_details.map((audioDetail, index) => (
//                             < AudioDetailsData
//                                 key={audioDetail.audio_id}
//                                 index={index}
//                                 audioDetail={audioDetail}
//                                 updateAudioStatusAndReason={updateAudioStatusAndReason}
//                                 setUpdateAudioStatusAndReason={setUpdateAudioStatusAndReason}
//                                 closeFunction={closeFunction}
//                             />
//                         ))}
//                     </Stack>
//                 )
//             })
//         }

//     }

//     useEffect(() => {
//         // Check if both audio_details have 'approved' status
//         if (
//             studentAudioData.data[0]?.audio_details[0]?.audio_status === 'approved' &&
//             studentAudioData.data[0]?.audio_details[1]?.audio_status === 'approved'
//         ) {
//             setDisableButton(true);
//         } else {
//             setDisableButton(false);
//         }
//     }, [studentAudioData, updateAudioStatusAndReason])

//     const sameField = () => {
//         let value = false
//         if (updateAudioStatusAndReason.data.length > 0) {
//             const audioStatus = updateAudioStatusAndReason.data.map((item) => item.audio_status)
//             console.log(audioStatus);
//             const areAllStatusesSame = audioStatus.every((status, index, array) => status === array[0]);
//             console.log(areAllStatusesSame, 'areAllStatusesSame');
//             if (areAllStatusesSame === true) {
//                 setUpdateAudioStatusAndReason((e) => ({ ...e, status: false }))
//                 value = true
//             } else if (areAllStatusesSame === false) {
//                 setUpdateAudioStatusAndReason((e) => ({ ...e, status: true }))
//                 value = false
//             }
//         }
//         return value
//     }

//     return (
//         <div>
//             <Modal
//                 open={openAudioModal}
//                 onClose={() => closeFunction()}
//                 aria-labelledby="modal-modal-title"
//                 aria-describedby="modal-modal-description"
//             >
//                 <Box sx={style}>
//                     <Stack pb={2} direction="row" alignItems="center" justifyContent="space-between">
//                         <Stack direction='row' alignItems="center" spacing={2}>
//                             <VolumeUp sx={{ color: "#1d3faa" }} />
//                             <Typography><span style={{ color: "#1d3faa", fontWeight: "bold" }}>Audio details</span>  ( For student - {studentAudioData.data[0]?.student_name} )</Typography>
//                         </Stack>
//                         <Box>
//                             <IconButton onClick={() => closeFunction()}>
//                                 <Close />
//                             </IconButton>
//                         </Box>
//                     </Stack>
//                     <Divider></Divider>
//                     <Stack>
//                         {content}
//                     </Stack>
//                     {studentAudioData.isSuccess && studentAudioData.data[0]?.level_name === "level0" && !disableButton && <Stack direction="row" pt={2} spacing={3} justifyContent="flex-end">
//                         <Button
//                             variant='contained'
//                             onClick={() => setOpenAudioModal(false)}
//                             sx={{
//                                 bgcolor: "white",
//                                 border: "1px solid gray",
//                                 color: "black",
//                                 "&:hover": {
//                                     bgcolor: "white",
//                                 }
//                             }}
//                         >
//                             Cancel
//                         </Button>
//                         {studentAudioData.data[0]?.audio_details[0] !== null &&

//                             <LoadingButton
//                                 loading={updateAudioStatusAndReason.isLoading}
//                                 onClick={() => {

//                                     if (sameField()) {
//                                         updateAudioStatusOfStudent();

//                                     }
//                                 }

//                                 }
//                                 variant='contained'
//                                 sx={{
//                                     bgcolor: "#1d3faa",
//                                     "&:hover": {
//                                         bgcolor: "#1d3faa",
//                                     }
//                                 }}
//                             >
//                                 Update
//                             </LoadingButton>
//                         }

//                     </Stack>}
//                 </Box>
//             </Modal>
//         </div>
//     );
// }

// export default AudioDetails;

// function AudioDetailsData({ audioDetail, index, setUpdateAudioStatusAndReason, updateAudioStatusAndReason, closeFunction }) {

//     const [data, setData] = useState({
//         audio_id: '',
//         audio_file_name: '',
//         audio_audit_by: '',
//         audio_uploaded_at: '',
//         audio_uploaded_by: '',
//         audio_source: '',
//         audio_status: '',
//         audio_reason: '',
//     });
//     const [statusAlert, setStatusAlert] = useState(false);
//     const username = sessionStorage.getItem("username");
//     const userId = sessionStorage.getItem("user_id");
//     console.log(updateAudioStatusAndReason);

//     // const sameStatus = updateAudioStatusAndReason.data.some(()={})

//     useEffect(() => {
//         setData(audioDetail);
//         if (audioDetail.audio_status === 'approved' && audioDetail.audio_status === 'resend') {
//             closeFunction()
//         }
//     }, [audioDetail,closeFunction]);

//     useEffect(() => {
//         setUpdateAudioStatusAndReason(prev => {
//             prev.data[index] = {
//                 audio_id: data.audio_id,
//                 audio_status: data.audio_status,
//                 audio_reason: data.audio_reason,
//                 audio_audit_by: username,
//                 audio_audit_by_id: userId,
//             };
//             return { ...prev, status: false };
//         });

//     }, [data, setUpdateAudioStatusAndReason, index,userId, username])

//     function AudioAlertModule({ open, onClose }) {

//         return (
//             <Modal
//                 open={open}
//                 onClose={onClose}
//                 aria-labelledby="modal-modal-title"
//                 aria-describedby="modal-modal-description"
//                 style={{ zIndex: 2000, position: 'fixed', }}
//             >
//                 <Box sx={styleBox}>
//                     <Stack pb={2} direction="row" alignItems="center" justifyContent="space-between" >
//                         <Stack>
//                             <h5 style={{ color: "#ff3333" }}>
//                                 Warning!&nbsp;
//                             </h5>
//                         </Stack>
//                         <Box>
//                             <IconButton onClick={onClose}>
//                                 <Close />
//                             </IconButton>
//                         </Box>
//                     </Stack>
//                     <Stack>
//                         <p>"Once you update the student audio file to 'approved,' you can't change it."</p>
//                     </Stack>
//                 </Box>

//             </Modal>
//         )
//     }
//     // console.log(audioDetail);
//     return (
//         <>
//             <Stack py={2}>
//                 <Stack direction="row" spacing={3}>
//                     {data.audio_file_name && <Typography variant='subtitle1'>Audio name:&nbsp; <span style={{ color: "gray" }}>{data.audio_file_name}</span></Typography>}
//                     {data.audio_audit_by && <Typography variant='subtitle1'>Audited by:&nbsp; <span style={{ color: "gray" }}>{data.audio_audit_by}</span></Typography>}
//                     {data.audio_uploaded_at && <Typography variant='subtitle1'>Uploaded on:&nbsp; <span style={{ color: "gray" }}>{dayjs(data.audio_uploaded_at).format("DD/MM/YYYY")}</span></Typography>}
//                     {data.audio_uploaded_by && <Typography variant='subtitle1'>Uploaded by:&nbsp; <span style={{ color: "gray" }}>{data.audio_uploaded_by}</span></Typography>}
//                 </Stack>
//                 <Stack
//                     spacing={4}
//                     direction="row"
//                     alignItems="center"
//                     justifyContent="space-between"
//                 >
//                     <Stack width="100%">
//                         <Typography variant='subtitle1'>Audio file</Typography>
//                         <ReactAudioPlayer
//                             style={{
//                                 border: "1px solid gray",
//                                 width: "inherit",
//                                 backgroundColor: "whitesmoke",
//                                 height: "40px",
//                                 borderRadius: "5px",
//                                 filter: "sepia(50%) grayscale(1) contrast(100%) invert(1%)"
//                             }}
//                             src={data.audio_source}
//                             controls
//                         />
//                         {!data.audio_source.endsWith(".wav") && !data.audio_source.endsWith(".mp3") && <Typography color="error" variant='subtitle1'>Audio file is not a valid format</Typography>}
//                     </Stack>
//                     {data.audio_status !== undefined && <Stack width="100%" p={1}>
//                         <Typography variant='subtitle1'>Status</Typography>
//                         <TextField
//                             // disabled={!data.audio_source.endsWith(".wav") && !data.audio_source.endsWith(".mp3")}
//                             sx={{
//                                 '& legend': { display: 'none' },
//                                 '& fieldset': { top: 0 },
//                             }}
//                             // disabled={audioDetail.audio_status === 'approved'}
//                             select
//                             size='small'
//                             fullWidth
//                             value={data.audio_status}
//                             onChange={(e) => {
//                                 setStatusAlert(e.target.value === 'approved' ? true : false);
//                                 setData(prev => ({ ...prev, audio_status: e.target.value }))
//                             }}
//                             helperText={updateAudioStatusAndReason?.status=== true && <span style={{color:'red'}}>*Both field should be same status</span> }
//                         >
//                             { }
//                             <MenuItem value="submitted" disabled >Submitted</MenuItem>
//                             <MenuItem value="approved" disabled={audioDetail.audio_status !== "submitted"}>Approved</MenuItem>
//                             <MenuItem value="resend">Resend</MenuItem>

//                         </TextField>
//                     </Stack>}
//                     {data.audio_reason !== undefined && <Stack width="100%" p={1}>
//                         <Typography variant='subtitle1'>Reason</Typography>
//                         <TextField
//                             sx={{
//                                 '& legend': { display: 'none' },
//                                 '& fieldset': { top: 0 },
//                             }}
//                             // disabled={!data.audio_source.endsWith(".wav") && !data.audio_source.endsWith(".mp3")}
//                             fullWidth
//                             placeholder='Enter reason'
//                             size='small'
//                             value={data.audio_reason}
//                             onChange={(e) => setData(prev => ({ ...prev, audio_reason: e.target.value }))}
//                         />
//                     </Stack>}
//                 </Stack>
//             </Stack>
//             <Divider sx={{ borderWidth: "1px" }} />

//             <AudioAlertModule
//                 open={statusAlert}
//                 onClose={() => setStatusAlert(false)}
//             />
//         </>
//     )
// }

import { Close, VolumeUp } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  MenuItem,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import ReactAudioPlayer from "react-audio-player";
import Axios from "../../../../../../axios/Axios";
import dayjs from "dayjs";
import { showSnackbar } from "../../../../../redux/features/appSlice";
import { useDispatch } from "react-redux";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

const styleBox = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  borderRadius: "8px",
};

function AudioDetails({
  openAudioModal,
  setOpenAudioModal,
  requestData,
  pageReload,
}) {
  // console.log(openAudioModal );
  // console.log(setOpenAudioModal);
  // console.log(requestData);
  const dispatch = useDispatch();
  const [studentAudioData, setStudentAudioData] = useState({
    isLoading: false,
    isError: false,
    isSuccess: false,
    data: [],
    error: null,
    // level_name,
  });

  const [updateAudioStatusAndReason, setUpdateAudioStatusAndReason] = useState({
    isLoading: false,
    status: false,
    data: [],
  });
  const updatedData = { ...studentAudioData.data[0] };
  delete updatedData.audio_details;
  //    console.log(updatedData);
  const { student_id, level_id, session_id } = updatedData;

  const value = {
    studentDetails: {
      student_id,
      level_id,
      session_id,
      teacher_id: requestData.teacherId,
    },
    audio: updateAudioStatusAndReason.data,
  };
  const [disableButton, setDisableButton] = useState(false);

  //    console.log(value,"value");
  //        console.log(studentAudioData.data[0], "audio");
  // console.log(updateAudioStatusAndReason.data, "new data");

  /* Get Audio details from API */
  useEffect(() => {
    const controller = axios.CancelToken.source();

    if (requestData.studentId && requestData.levelId && requestData.levelName) {
      (async () => {
        try {
          setStudentAudioData((prev) => ({
            ...prev,
            isLoading: true,
            isSuccess: false,
            isError: false,
            data: [],
            error: null,
          }));
          let options =
            requestData.levelName === "level0"
              ? {
                  method: "GET",
                  url: `audio/student/level0/audio/for/spoc/${requestData.studentId}`,
                  auth: true,
                  data: null,
                  token: { cancelToken: controller.token },
                }
              : {
                  method: "POST",
                  url: "audio/student/level/status/for/spoc",
                  auth: true,
                  data: {
                    student_id: requestData.studentId,
                    level_id: requestData.levelId,
                  },
                  token: { cancelToken: controller.token },
                };

          const response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token
          );

          // console.log(response);
          if (response.status === 200) {
            setStudentAudioData((prev) => ({
              ...prev,
              isSuccess: true,
              data: response.data,
            }));
            // setUpdateAudioStatusAndReason(prev =>({...prev, ...response.data[0]}))
          }
        } catch (error) {
          if (!axios.isCancel(error)) {
            setStudentAudioData((prev) => ({
              ...prev,
              isError: true,
              error: error.data,
            }));
            console.log(error);
          }
        }
      })();
    }

    return () => {
      controller.cancel();
    };
  }, [requestData]);

  /* Update audio status and reason for student */
  async function updateAudioStatusOfStudent() {
    try {
      setUpdateAudioStatusAndReason((prev) => ({ ...prev, isLoading: true }));
      let options = {
        method: "PUT",
        url: "audio/student/approval/by/user",
        auth: true,
        data: value,
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      // console.log(response);
      if (response.status === 200 || response.status === 201) {
        await fetchAudioDetails();
        setUpdateAudioStatusAndReason((prev) => ({
          ...prev,
          isLoading: false,
        }));
        dispatch(
          showSnackbar({
            message: "Audio status updated successfully",
            severity: "success",
          })
        );
      }
    } catch (error) {
      setUpdateAudioStatusAndReason((prev) => ({ ...prev, isLoading: false }));
      dispatch(
        showSnackbar({
          message: "Failed updating audio status, Try again",
          severity: "error",
        })
      );

      console.log(error);
    }
  }

  async function fetchAudioDetails() {
    try {
      setStudentAudioData((prev) => ({
        ...prev,
        isLoading: true,
        isSuccess: false,
        isError: false,
        data: [],
        error: null,
      }));
      let options =
        requestData.levelName === "level0"
          ? {
              method: "GET",
              url: `audio/student/level0/audio/for/spoc/${requestData.studentId}`,
              auth: true,
              data: null,
            }
          : {
              method: "POST",
              url: "audio/student/level/status/for/spoc",
              auth: true,
              data: {
                student_id: requestData.studentId,
                level_id: requestData.levelId,
              },
            };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      // console.log(response);
      if (response.status === 200) {
        setStudentAudioData((prev) => ({
          ...prev,
          isSuccess: true,
          data: response.data,
        }));
        // setUpdateAudioStatusAndReason(prev =>({...prev, ...response.data[0]}))
      }
    } catch (error) {
      setStudentAudioData((prev) => ({
        ...prev,
        isError: true,
        error: error.data,
      }));
      console.log(error);
    }
  }

  const closeFunction = () => {
    pageReload();
    setOpenAudioModal(false);
  };

  /* Render audio details */
  let content;

  if (studentAudioData.isLoading) {
    content = (
      <Box sx={{ p: 5, margin: "0 auto" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (studentAudioData.isError) {
    content = (
      <Box sx={{ p: 5, margin: "0 auto" }}>
        <p>{studentAudioData.error}</p>
      </Box>
    );
  }

  if (studentAudioData.isSuccess) {
    if (
      studentAudioData.data.length === 0 ||
      studentAudioData.data[0] === null
    ) {
      content = (
        <Box sx={{ p: 5, margin: "0 auto" }}>
          <p>Data not available</p>
        </Box>
      );
    } else if (studentAudioData.data[0]?.audio_details[0] === null) {
      content = (
        <Box sx={{ p: 5, margin: "0 auto" }}>
          <p>Audio file not available</p>
        </Box>
      );
    } else {
      content = studentAudioData.data.map((audiodata, i) => {
        return (
          <Stack key={i} pt={1}>
            <Typography fontWeight="bold" variant="subtitle1" color="#1d3faa">
              {audiodata.level_name} - {audiodata.session_name}
            </Typography>
            {audiodata.audio_details.map((audioDetail, index) => (
              <AudioDetailsData
                key={audioDetail.audio_id}
                index={index}
                audioDetail={audioDetail}
                updateAudioStatusAndReason={updateAudioStatusAndReason}
                setUpdateAudioStatusAndReason={setUpdateAudioStatusAndReason}
                closeFunction={closeFunction}
              />
            ))}
          </Stack>
        );
      });
    }
  }

  useEffect(() => {
    // Check if both audio_details have 'approved' status
    if (
      studentAudioData.data[0]?.audio_details[0]?.audio_status === "approved" &&
      studentAudioData.data[0]?.audio_details[1]?.audio_status === "approved"
    ) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
  }, [studentAudioData, updateAudioStatusAndReason]);

  const sameField = () => {
    let value = false;
    if (updateAudioStatusAndReason.data.length > 0) {
      const audioStatus = updateAudioStatusAndReason.data.map(
        (item) => item.audio_status
      );
      console.log(audioStatus);
      const areAllStatusesSame = audioStatus.every(
        (status, index, array) => status === array[0]
      );
      console.log(areAllStatusesSame, "areAllStatusesSame");
      if (areAllStatusesSame === true) {
        setUpdateAudioStatusAndReason((e) => ({ ...e, status: false }));
        value = true;
      } else if (areAllStatusesSame === false) {
        setUpdateAudioStatusAndReason((e) => ({ ...e, status: true }));
        value = false;
      }
    }
    return value;
  };

  return (
    <div>
      <Modal
        open={openAudioModal}
        onClose={() => closeFunction()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            pb={2}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <VolumeUp sx={{ color: "#1d3faa" }} />
              <Typography>
                <span style={{ color: "#1d3faa", fontWeight: "bold" }}>
                  Audio details
                </span>{" "}
                ( For student - {studentAudioData.data[0]?.student_name} )
              </Typography>
            </Stack>
            <Box>
              <IconButton onClick={() => closeFunction()}>
                <Close />
              </IconButton>
            </Box>
          </Stack>
          <Divider></Divider>
          <Stack>{content}</Stack>
          {studentAudioData.isSuccess &&
            studentAudioData.data[0]?.level_name === "level0" &&
            !disableButton && (
              <Stack
                direction="row"
                pt={2}
                spacing={3}
                justifyContent="flex-end"
              >
                <Button
                  variant="contained"
                  onClick={() => setOpenAudioModal(false)}
                  sx={{
                    bgcolor: "white",
                    border: "1px solid gray",
                    color: "black",
                    "&:hover": {
                      bgcolor: "white",
                    },
                  }}
                >
                  Cancel
                </Button>
                {studentAudioData.data[0]?.audio_details[0] !== null && (
                  <LoadingButton
                    loading={updateAudioStatusAndReason.isLoading}
                    onClick={() => {
                      if (sameField()) {
                        updateAudioStatusOfStudent();
                      }
                    }}
                    variant="contained"
                    sx={{
                      bgcolor: "#1d3faa",
                      "&:hover": {
                        bgcolor: "#1d3faa",
                      },
                    }}
                  >
                    Update
                  </LoadingButton>
                )}
              </Stack>
            )}
        </Box>
      </Modal>
    </div>
  );
}

export default AudioDetails;

function AudioDetailsData({
  audioDetail,
  index,
  setUpdateAudioStatusAndReason,
  updateAudioStatusAndReason,
  closeFunction,
}) {
  const [data, setData] = useState({
    audio_id: "",
    audio_file_name: "",
    audio_audit_by: "",
    audio_uploaded_at: "",
    audio_uploaded_by: "",
    audio_source: "",
    audio_status: "",
    audio_reason: "",
  });
  const [statusAlert, setStatusAlert] = useState(false);
  const [pendingStatus, setPendingStatus] = useState("");

  const username = sessionStorage.getItem("username");
  const userId = sessionStorage.getItem("user_id");

  // const sameStatus = updateAudioStatusAndReason.data.some(()={})

  useEffect(() => {
    setData(audioDetail);
    if (
      audioDetail.audio_status === "approved" &&
      audioDetail.audio_status === "resend"
    ) {
      closeFunction();
    }
  }, [audioDetail]);

  useEffect(() => {
    setUpdateAudioStatusAndReason((prev) => {
      prev.data[index] = {
        audio_id: data.audio_id,
        audio_status: data.audio_status,
        audio_reason: data.audio_reason,
        audio_audit_by: username,
        audio_audit_by_id: userId,
      };
      return { ...prev, status: false };
    });
  }, [data, setUpdateAudioStatusAndReason, index, username]);

  function AudioAlertModule({ open, onClose, onConfirm }) {
    return (
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ zIndex: 2000, position: "fixed" }}
      >
        <Box sx={styleBox}>
          <Stack
            pb={2}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack>
              <h5 style={{ color: "#ff3333" }}>Warning!&nbsp;</h5>
            </Stack>
            <Box>
              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            </Box>
          </Stack>
          <Stack>
            <p>
              "Once you update the student audio file to 'approved,' you can't
              change it."
            </p>
            <Stack direction="row" spacing={2} justifyContent="flex-end ">
              <button
                onClick={() => {
                  onClose();
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#ccc",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  onClose();
                  onConfirm();
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#ff3333",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                OK
              </button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    );
  }
  // console.log(audioDetail);
  return (
    <>
      <Stack py={2}>
        <Stack direction="row" spacing={3}>
          {data.audio_file_name && (
            <Typography variant="subtitle1">
              Audio name:&nbsp;{" "}
              <span style={{ color: "gray" }}>{data.audio_file_name}</span>
            </Typography>
          )}
          {data.audio_audit_by && (
            <Typography variant="subtitle1">
              Audited by:&nbsp;{" "}
              <span style={{ color: "gray" }}>{data.audio_audit_by}</span>
            </Typography>
          )}
          {data.audio_uploaded_at && (
            <Typography variant="subtitle1">
              Uploaded on:&nbsp;{" "}
              <span style={{ color: "gray" }}>
                {dayjs(data.audio_uploaded_at).format("DD/MM/YYYY")}
              </span>
            </Typography>
          )}
          {data.audio_uploaded_by && (
            <Typography variant="subtitle1">
              Uploaded by:&nbsp;{" "}
              <span style={{ color: "gray" }}>{data.audio_uploaded_by}</span>
            </Typography>
          )}
        </Stack>
        <Stack
          spacing={4}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack width="100%">
            <Typography variant="subtitle1">Audio file</Typography>
            <ReactAudioPlayer
              style={{
                border: "1px solid gray",
                width: "inherit",
                backgroundColor: "whitesmoke",
                height: "40px",
                borderRadius: "5px",
                filter: "sepia(50%) grayscale(1) contrast(100%) invert(1%)",
              }}
              src={data.audio_source}
              controls
            />
            {!data.audio_source.endsWith(".wav") &&
              !data.audio_source.endsWith(".mp3") &&  !data.audio_source.endsWith(".m4a") && (
                <Typography color="error" variant="subtitle1">
                  Audio file is not a valid format
                </Typography>
              )}
          </Stack>
          {data.audio_status !== undefined && (
            <Stack width="100%" p={1}>
              <Typography variant="subtitle1">Status</Typography>
              <TextField
                // disabled={!data.audio_source.endsWith(".wav") && !data.audio_source.endsWith(".mp3")}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                // disabled={audioDetail.audio_status === 'approved'}
                select
                size="small"
                fullWidth
                value={data.audio_status}
                // onChange={(e) => {
                //   const selected = e.target.value;
                //   setStatusAlert(e.target.value === "approved" ? true : false);
                //   setData((prev) => ({
                //     ...prev,
                //     audio_status: statusAlertConfirm
                //       ? "approved"
                //       : !statusAlertConfirm
                //       ? "submitted"
                //       : "resend",
                //   }));
                // }}
                onChange={(e) => {
                  const selected = e.target.value;

                  if (selected === "approved") {
                    setPendingStatus("approved");
                    setStatusAlert(true);
                  } else {
                    setPendingStatus("");
                    setData((prev) => ({
                      ...prev,
                      audio_status: selected,
                    }));
                  }
                }}
                helperText={
                  updateAudioStatusAndReason?.status === true && (
                    <span style={{ color: "red" }}>
                      *Both field should be same status
                    </span>
                  )
                }
              >
                {}
                <MenuItem value="submitted" disabled>
                  Submitted
                </MenuItem>
                <MenuItem
                  value="approved"
                  disabled={
                    audioDetail.audio_status !== "submitted" 
                  
                  }
                >
                  Approved
                </MenuItem>
                <MenuItem value="resend">Resend</MenuItem>
              </TextField>
            </Stack>
          )}
          {data.audio_reason !== undefined && (
            <Stack width="100%" p={1}>
              <Typography variant="subtitle1">Reason</Typography>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                // disabled={!data.audio_source.endsWith(".wav") && !data.audio_source.endsWith(".mp3")}
                fullWidth
                placeholder="Enter reason"
                size="small"
                value={data.audio_reason}
                onChange={(e) =>
                  setData((prev) => ({ ...prev, audio_reason: e.target.value }))
                }
              />
            </Stack>
          )}
        </Stack>
      </Stack>
      <Divider sx={{ borderWidth: "1px" }} />

      {/* <AudioAlertModule
        open={statusAlert}
        onClose={() => setStatusAlert(false)}
        onConfirm={() => setStatusAlertConfirm(true)}
      /> */}

      <AudioAlertModule
        open={statusAlert}
        onClose={() => {
          setStatusAlert(false);
          setPendingStatus("");
        }}
        onConfirm={() => {
          setStatusAlert(false);
          setData((prev) => ({
            ...prev,
            audio_status: pendingStatus,
          }));
          setPendingStatus("");
        }}
      />
    </>
  );
}
